export default "__VITE_ASSET__398004c1__"